import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M854.396582,1594.87362 C446.108936,1594.87362 113.919544,1262.68423 113.919544,854.396582 C113.919544,446.108936 446.108936,113.919544 854.396582,113.919544 C1262.68423,113.919544 1594.87362,446.108936 1594.87362,854.396582 C1594.87362,1262.68423 1262.68423,1594.87362 854.396582,1594.87362 L854.396582,1594.87362 Z M1920,1839.34496 L1496.67497,1416.13386 C1628.25205,1265.64614 1708.79316,1069.5906 1708.79316,854.396582 C1708.79316,383.225347 1325.56782,0 854.396582,0 C383.225347,0 0,383.225347 0,854.396582 C0,1325.56782 383.225347,1708.79316 854.396582,1708.79316 C1069.47668,1708.79316 1265.76006,1628.25205 1416.13386,1496.67497 L1839.34496,1920 L1920,1839.34496 Z M911.356355,455.678177 L797.43681,455.678177 L797.43681,797.43681 L455.678177,797.43681 L455.678177,911.356355 L797.43681,911.356355 L797.43681,1253.11499 L911.356355,1253.11499 L911.356355,911.356355 L1253.11499,911.356355 L1253.11499,797.43681 L911.356355,797.43681 L911.356355,455.678177 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconZoomInLine = /*#__PURE__*/function (_Component) {
  _inherits(IconZoomInLine, _Component);

  var _super = _createSuper(IconZoomInLine);

  function IconZoomInLine() {
    _classCallCheck(this, IconZoomInLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconZoomInLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconZoomIn",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconZoomInLine.displayName = "IconZoomInLine";
  return IconZoomInLine;
}(Component);

IconZoomInLine.glyphName = 'zoom-in';
IconZoomInLine.variant = 'Line';
IconZoomInLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconZoomInLine;
export { IconZoomInLine };